module.exports = __webpack_public_path__ + "static/media/related-cases-of-banner.3c4fbed0.jpg";